import React from 'react';
import { Card, Input, Space, Button, Select } from 'antd';
import dayjs from 'dayjs';

const TimestampTool: React.FC = () => {
  const [now, setNow] = React.useState(() => Math.floor(Date.now() / 1000));
  const [tsInput, setTsInput] = React.useState('');
  const [tsUnit, setTsUnit] = React.useState<'s' | 'ms'>('s');
  const [dateResult, setDateResult] = React.useState('');
  const [dateInput, setDateInput] = React.useState('');
  const [tsResult, setTsResult] = React.useState('');
  const [resultUnit, setResultUnit] = React.useState<'s' | 'ms'>('s');

  React.useEffect(() => {
    const timer = setInterval(() => setNow(Math.floor(Date.now() / 1000)), 1000);
    return () => clearInterval(timer);
  }, []);

  // 时间戳转日期
  const handleTsToDate = () => {
    const raw = tsInput.trim();
    let tsNum = Number(raw);
    if (isNaN(tsNum) || tsNum <= 0) {
      setDateResult('格式错误');
      return;
    }
    if (tsUnit === 'ms') {
      tsNum = Math.floor(tsNum / 1000);
    }
    const d = dayjs.unix(tsNum);
    setDateResult(d.format('YYYY-MM-DD HH:mm:ss'));
  };

  // 日期转时间戳
  const handleDateToTs = () => {
    const d = dayjs(dateInput.trim());
    if (!d.isValid()) {
      setTsResult('格式错误');
      return;
    }
    let ts = d.unix();
    if (resultUnit === 'ms') {
      ts = ts * 1000;
    }
    setTsResult(ts.toString());
  };

  return (
    <Card title="时间转换" className="tool-container-responsive">
      <div style={{ marginBottom: 16, textAlign: 'center', fontWeight: 500 }}>
        当前时间戳：{now}（秒）
      </div>
      <Space style={{ width: '100%', marginBottom: 12 }}>
        <Input
          placeholder="输入时间戳"
          value={tsInput}
          onChange={e => setTsInput(e.target.value)}
          style={{ flex: 1 }}
        />
        <Select value={tsUnit} onChange={setTsUnit} style={{ width: 80 }}>
          <Select.Option value="s">秒</Select.Option>
          <Select.Option value="ms">毫秒</Select.Option>
        </Select>
        <Button type="primary" onClick={handleTsToDate}>转换为日期</Button>
        <Input
          placeholder="YYYY-MM-DD HH:mm:ss"
          value={dateResult}
          readOnly
          style={{ flex: 1 }}
        />
      </Space>
      <Space style={{ width: '100%' }}>
        <Input
          placeholder="输入日期 YYYY-MM-DD HH:mm:ss"
          value={dateInput}
          onChange={e => setDateInput(e.target.value)}
          style={{ flex: 1 }}
        />
        <Button type="primary" onClick={handleDateToTs}>转换为时间戳</Button>
        <Select value={resultUnit} onChange={setResultUnit} style={{ width: 80 }}>
          <Select.Option value="s">秒</Select.Option>
          <Select.Option value="ms">毫秒</Select.Option>
        </Select>
        <Input
          placeholder="Unix时间戳"
          value={tsResult}
          readOnly
          style={{ flex: 1 }}
        />
      </Space>
    </Card>
  );
};

export default TimestampTool; 